import { keys } from "../config/keys";
import resolveCompanyId from "./resolveCompanyId";

export const STANDALONE_FEATURES = {
  COMPANIES: {
    path: "/standalone/companies",
    title: "Registered Companies",
  },
  COMPANY_ADMINS: {
    path: "/standalone/company-admins",
    title: "Admins",
  },
  FELLOW_ADMINS: {
    path: "/standalone/fellow-admins",
    title: "Fellow Admins",
  },
  MANAGE_TEAMS: {
    path: "/standalone/manage-teams",
    title: "Manage Teams",
  },
  MANAGE_SITES: {
    path: "/standalone/manage-sites",
    title: "Manage Sites",
  },
};

export const isStandalonePath = (pathname = "") => pathname.startsWith("/standalone");

export const buildStandaloneUrl = (featurePath, options = {}) => {
  const base = (keys.CLIENT_ORIGIN || window.location.origin).replace(/\/+$/, "");
  const normalizedPath = featurePath.startsWith("/") ? featurePath : `/${featurePath}`;
  const params = new URLSearchParams();

  const token = options.token ?? localStorage.getItem("token") ?? "";
  const sessionKey = options.session_key ?? localStorage.getItem("session_key") ?? "";

  if (token) params.set("token", token);
  if (sessionKey) params.set("session_key", sessionKey);

  const returnUrl = options.returnUrl ?? window.location.href;
  if (returnUrl) params.set("returnUrl", returnUrl);

  if (options.companyID) {
    const resolvedCompanyID = resolveCompanyId(options.companyID);
    if (resolvedCompanyID) params.set("companyID", resolvedCompanyID);
  }
  if (options.branchID) params.set("branchID", options.branchID);
  if (options.admin) params.set("admin", "true");

  const query = params.toString();
  return query ? `${base}${normalizedPath}?${query}` : `${base}${normalizedPath}`;
};

export const openStandaloneFeature = (featurePath, options = {}) => {
  window.open(buildStandaloneUrl(featurePath, options), "_blank", "noopener,noreferrer");
};

export const canAccessStandaloneFeature = (featureKey, authFlags = {}) => {
  const {
    isAdmin = false,
    isCompany = false,
    isCompanyAdmin = false,
    isFellowAdmin = false,
    isManager = false,
    isHR = false,
    branchID = null,
  } = authFlags;

  const hasBranchId = Boolean(branchID);
  const isCompanyLevelHrOrManager = (isHR || isManager) && !hasBranchId;

  switch (featureKey) {
    case "COMPANIES":
      return isAdmin;
    case "COMPANY_ADMINS":
      return isAdmin && !isCompanyAdmin && !isFellowAdmin;
    case "FELLOW_ADMINS":
      return isAdmin && !isFellowAdmin;
    case "MANAGE_TEAMS":
      if (isAdmin || isCompanyLevelHrOrManager) return false;
      return isCompany || hasBranchId;
    case "MANAGE_SITES":
      if (isAdmin || isCompanyLevelHrOrManager) return false;
      return isCompany;
    default:
      return false;
  }
};
